import { modifier } from "../modifiers";

modifier("not", (value) => !value);
